import React from 'react';
import { useTranslation } from 'react-i18next';
import FontAwesome from '../uiStyle/FontAwesome';

/**
 * FollowUs Component
 * Displays social media links and a newsletter subscription link.
 */
const FollowUs = ({ className = '', title }) => {
  const { t } = useTranslation();

  return (
    <div className={`follow_box widget mb30 ${className}`}>
      {/* Widget title */}
      <h2 className="widget-title">{title}</h2>
      <div className="space-20" />
      <div className="cta">
        {/* Social media icons */}
        <div className="social2">
          <ul className="d-flex justify-content-center justify-content-lg-between">
            <li>
              <a
                href="https://www.facebook.com/RegioHealthNews"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesome name="facebook-f" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/regiohealth.news"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesome name="instagram" />
              </a>
            </li>
            <li>
              <a
                href="https://gesundheitsticket.de/rss"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesome name="rss" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@RegioHealthNetzwerk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesome name="youtube-play" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/regiohealth-network"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesome name="linkedin" />
              </a>
            </li>
          </ul>
        </div>
        {/* Newsletter subscription link */}
        <div className="news_letter">
          <div className="newsletter">
            <ul className="inline">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://479eae97.sibforms.com/serve/MUIEAEvroLOl7gAeKgjfkbLkysmfsuAS3Tg6HJf6pH3obY0A938-9XXoyezLoftkDhOte_IPJ4UzRcIaiUwNZVuQPKYRpGLaLvT5TZ5udL7Bhv2Vlh9onojMKyw5UxBFiuAoIcA89fFusp3sdopMgDpkOXeSLuurQRJPPChbLNNYIGmg4-8iLrJQA8l6xcpt-8K9i8z56LepgN9j"
                >
                  {t('followUs.subscribeNewsletter')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUs;
